
import { useState, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Key, Lock } from "lucide-react";
import { toast } from "@/components/ui/use-toast";
import { generateApiKey } from "@/services/wordpressPluginService";

export const ApiKeyGenerator = () => {
  const [apiKey, setApiKey] = useState("");
  const [showApiKey, setShowApiKey] = useState(false);
  const apiKeyRef = useRef<HTMLInputElement>(null);

  const handleGenerateApiKey = () => {
    const newApiKey = generateApiKey();
    setApiKey(newApiKey);
    toast({
      title: "API Key Generated",
      description: "Your API key has been generated. Keep it secure!",
    });
  };

  const handleCopyApiKey = () => {
    if (apiKeyRef.current) {
      apiKeyRef.current.select();
      document.execCommand('copy');
      toast({
        title: "Copied to clipboard",
        description: "API key has been copied to clipboard",
      });
    }
  };

  return (
    <div className="p-4 bg-gray-100 rounded-md mt-2">
      <div className="grid gap-4">
        <div>
          <Label htmlFor="site-id">Your Site ID</Label>
          <div className="flex mt-1">
            <Input id="site-id" value="1" readOnly />
            <Button 
              variant="secondary" 
              size="sm" 
              className="ml-2" 
              onClick={() => {
                navigator.clipboard.writeText("1");
                toast({
                  title: "Copied to clipboard",
                  description: "Site ID has been copied to clipboard",
                });
              }}
            >
              Copy
            </Button>
          </div>
        </div>
        <div>
          <Label htmlFor="api-key">API Key</Label>
          <div className="flex mt-1">
            <div className="relative flex-1">
              <Input 
                id="api-key" 
                value={apiKey || "Generate an API key"} 
                readOnly 
                ref={apiKeyRef}
                type={showApiKey ? "text" : "password"}
              />
              <button 
                type="button"
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                onClick={() => setShowApiKey(!showApiKey)}
              >
                {showApiKey ? <Lock className="h-4 w-4" /> : <Key className="h-4 w-4" />}
              </button>
            </div>
            {!apiKey ? (
              <Button variant="secondary" size="sm" className="ml-2" onClick={handleGenerateApiKey}>
                Generate
              </Button>
            ) : (
              <Button variant="secondary" size="sm" className="ml-2" onClick={handleCopyApiKey}>
                Copy
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
